export default __webpack_public_path__ + "static/media/cp_geo_je.dc65ecab.svg";